var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "bonita-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveBonita.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-2"
  }, [_c('div', {
    staticClass: "inlineInputs"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "vek"
    }
  }, [_vm._v("Vek alebo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.vek_v_case_vyplnania,
      expression: "form.vek_v_case_vyplnania",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input leftItem",
    attrs: {
      "disabled": _vm.ageCalculated,
      "type": "number",
      "maxlength": "256",
      "min": "1",
      "name": "vek",
      "id": "vek"
    },
    domProps: {
      "value": _vm.form.vek_v_case_vyplnania
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "vek_v_case_vyplnania", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("dátum narodenia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.datum_narodenia,
      expression: "form.datum_narodenia"
    }],
    staticClass: "text-input w-input date-input rightItem",
    attrs: {
      "name": "dateOfBirth",
      "type": "date",
      "max": _vm.todayLong,
      "maxlength": "256"
    },
    domProps: {
      "value": _vm.form.datum_narodenia
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "datum_narodenia", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'rodinny_stav',
      "init-value": _vm.form.rodinny_stav,
      "options": _vm.formTemplate.rodinny_stav.choices,
      "value-correction": _vm.rodinnyStavCorrection,
      "normal": "",
      "name": 'Rodinný stav'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'rodinny_stav');
      },
      "value-corrected": function valueCorrected($event) {
        _vm.rodinnyStavCorrection = null;
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'vzdelanie',
      "init-value": _vm.form.vzdelanie,
      "options": _vm.formTemplate.vzdelanie.choices,
      "normal": "",
      "name": 'Vzdelanie'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'vzdelanie');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'aktualne_byvate',
      "init-value": _vm.form.aktualne_byvate,
      "options": _vm.formTemplate.aktualne_byvate.choices,
      "normal": "",
      "name": 'V súčastnosti bývam v nehnuteľnosti'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'aktualne_byvate');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'zuzene_bsm',
      "init-value": _vm.form.zuzene_bsm,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Zúžené BSM'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'zuzene_bsm');
      }
    }
  })], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'osobitny_vztah_k_banke',
      "init-value": _vm.form.osobitny_vztah_k_banke,
      "options": _vm.booleanForm,
      "normal": "",
      "name": 'Osobitý vzťah ku banke'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'osobitny_vztah_k_banke');
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }